import { SxProps, Theme } from '@mui/material/styles';

export const CALENDAR_SX: SxProps<Theme> = {
  '& .MuiDayPicker-weekDayLabel': {
    color: (theme) => theme.palette.tertiary.main,
  },
  '& .MuiPickersDay-root': {
    fontWeight: 600,
  },
  '& .MuiPickersDay-root.Mui-selected': {
    backgroundColor: (theme) => theme.palette.tertiary.main,
    color: (theme) => theme.palette.tertiary.contrastText,
    '&:hover, &:focus': {
      backgroundColor: (theme) => theme.palette.tertiary.dark,
    },
  },
  '& .PrivatePickersYear-yearButton.Mui-selected, & .PrivatePickersYear-yearButton.PrivatePickersYear-selected': {
    backgroundColor: (theme) => theme.palette.tertiary.main,
    color: (theme) => theme.palette.tertiary.contrastText,
    '&:hover, &:focus': {
      backgroundColor: (theme) => theme.palette.tertiary.dark,
    },
  },
};
